import { render } from "./CertificateBoard.vue?vue&type=template&id=2af72f84&scoped=true"
import script from "./CertificateBoard.vue?vue&type=script&lang=js"
export * from "./CertificateBoard.vue?vue&type=script&lang=js"

import "./CertificateBoard.vue?vue&type=style&index=0&id=2af72f84&scoped=true&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/certificate-site-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af72f84"]])

export default __exports__